import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { FormattedMessage } from "react-intl";
import { Space, Row } from "@masterteam/mt-design-react";

import Table from "../../NewTable";
import KPIChangeRequestsMenu from "../KPIChangeRequestsMenu";

import useIsAr from "../../../Hooks/useIsAr";
import { formatDate, getLookupName, getStatusKPIName } from "../../../helpers";

import { ReactComponent as ViewIcon } from "../../../assets/images/actions.svg";

import "./style.scss";

function KPIChangeRequests({ changeRequests, KPIDetails, getData }) {
  const history = useHistory();
  const [isAr, locale] = useIsAr();

  const [requestStatuses, changeRequestChangeType] = useSelector(
    ({ theme }) => [
      theme.WorkflowStatus.item.Items,
      theme.ChangeRequestChangeType.item.Items
    ]
  );

  useEffect(() => {
    getData();
  }, []);

  const columns = [
    {
      key: "request-type",
      header: <FormattedMessage id="change-request.request-type" />,
      cell: (item) =>
        getLookupName(
          changeRequestChangeType,
          item?.Form?.ChangeType?.toString(),
          isAr
        ),
      width: "20%"
    },
    {
      header: <FormattedMessage id="change-request.creation-date" />,
      cell: (item) => formatDate(item?.Created),
      width: "20%"
    },
    {
      header: <FormattedMessage id="change-request.creator" />,
      cell: (item) => item?.RequestedByModel?.DisplayName,
      width: "20%"
    },
    {
      header: <FormattedMessage id="common.status" />,
      cell: (item) =>
        item.Status !== null
          ? getStatusKPIName(requestStatuses, item.Status?.toString(), locale)
          : "---",
      width: "20%"
    },
    {
      header: <FormattedMessage id="change-request.action" />,
      cell: (item) => (
        <div className="icon-wrapper">
          <ViewIcon
            onClick={(e) => {
              e.stopPropagation();
              if (+item?.Form?.ChangeType === 1)
                history.push(`/splus/change-kpi-details/${item?.ID}`);
              else if (+item?.Form?.ChangeType === 2)
                history.push(`/splus/change-kpi-measurements/${item?.ID}`);
              else if (+item?.Form?.ChangeType === 3)
                history.push(`/splus/change-kpi-actual-values/${item?.ID}`);
              else if (+item?.Form?.ChangeType === 4)
                history.push(`/splus/change-kpi-parameters/${item?.ID}`);
            }}
          />
        </div>
      ),
      width: "20%"
    }
  ];

  return (
    <div className="change-requests-section" style={{ margin: "0 32px" }}>
      <Space direction="vertical" size="medium">
        <Row
          className="change-requests-section__header"
          justify="between"
          align="center"
        >
          <div className="title">
            <FormattedMessage id="change-request.title" />
          </div>
          <KPIChangeRequestsMenu KPIDetails={KPIDetails} />
        </Row>

        <div className="change-requests-section__content">
          <Table
            data={changeRequests}
            columns={columns}
            headerHasBackgroundColor
          />

          {changeRequests?.length ? null : (
            <Row
              justify="center"
              align="center"
              style={{ height: "100%", padding: "24px 0", fontSize: "16px" }}
            >
              <FormattedMessage id="no-data" />
            </Row>
          )}
        </div>
      </Space>
    </div>
  );
}

export default KPIChangeRequests;
